<template>
  <div class="pg-passport-systemEnterNew">
    <ul class="system-list" ref="listRef">
      <template v-if="systemList.length > 0">
        <li class="system-list-item"
          :style="itemStyle"
          v-for="(item, index) in systemList"
          :key="item.id + index"
          @click="systemEntrance(item)"
        >
        <div class="system-list-item-content">
           <div class="system-list-item-icon">
            <img v-if="item.icon" :src="getImage(item.icon)" >
            <i class="el-icon-picture-outline" v-else></i>
           </div>
          <div class="system-list-item-info">
            <span class="name">{{ item.name }}</span>
            <span class="title" :class="{'title-vnion': item.theme === 'vnion' || item.title === '移动端', 'title-link': item.theme === 'link', 'title-reunion': item.theme === 'reunion'}" v-if="item.title">{{ item.title }}</span>
          </div>
        </div>
        </li>
      </template>
      <template v-else>
        <li class="nodata">
          <span class="name">暂无系统列表</span>
        </li>
      </template>
    </ul>
    <ElDialog
      top=""
      custom-class="pg-passport-dialog-select-organization"
      fullscreen
      show-close
      :visible.sync="organizationModalShow"
      width="100%"
    >
      <span class="title">请选择需要登录的企业</span>
      <div class="select-organization">
        <PgInput
          class="input-search"
          placeholder="请输入企业名称"
          clearable
          v-model="keyowrd"
          @keyup.enter.native="seachOrganization()"
        >
          <template #prefix>
            <i class="ivu-icon-icon-pg-serach input-sea-icon"></i>
          </template>
        </PgInput>
      </div>
      <div class="select-organization-list">
        <div class="select-organization-list-item" v-for="(item, index) in organizationDatas" :key="item.id + index" @click="toSystem({organization: item.code})">
          <div class="select-organization-list-item-content">
            <div class="select-organization-list-item-icon">
              <img v-if="item.logo" :src="item.logo">
              <i class="ivu-icon-icon-pg-mrtx" v-else></i>
            </div>
            <span class="select-organization-list-item-name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="select-organization-list-footer">
        <PgPagination
          class="select-organization-list-footer-page"
          :total="totalCount"
          :pageSize.sync="page.pageSize"
          :pageSizes="[40, 80, 120, 200]"
          :current-page.sync="page.pageNo"
          @size-change="sizeChange"
          @current-change="currentChange"
        />
      </div>
    </ElDialog>
  </div>
</template>
<script>
export default {
  name: 'systemEntrance',
}
</script>
<script setup>
import { ref, shallowRef, onMounted, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router/composables'
import { get, post, pgMessage, getFullUrl, ElDialog, PgInput, ElLoading, PgPagination } from 'pangu-components-plus'

const getImage = (name) => {
  console.log('getImage', name)
  if(name.includes('/')) {
    return ''
  }
  try {
    return require(`../../../static/images/system-icon/${name}`)
  } catch (error) {
    return ''
  }
}
const listRef = ref(null)
const itemStyle = shallowRef({})
onMounted(() => {
  const width = listRef.value.offsetWidth
  const itemWidth = width / 5 - 80
  itemStyle.value = {
    width: itemWidth >= 320 ? 'calc(20% - 16px)' : '320px',
  }
})

const { proxy } = getCurrentInstance()
const systemList = shallowRef([])
const getSystemList = async () => { 
  const [res] = await get('rest/main/index/getSystemList', { platformCode: proxy.$store.state.user.platformCode})
  if(res) {
    systemList.value = res.data ?? []
    chainRouter()
  }
}
onMounted(() => { getSystemList() })

const organizationModalShow = ref(false)

const keyowrd = ref('')
const totalCount = ref(0)
// 获取系统组织列表
const getOrganizationBySystem = async (param) => {
  const [res] = await post('rest/main/index/getOrganizationPaged', {
    criteriaCode: 'PASSPORT_INDEX_ORGANIZATION_USER_SYSTEM_PAGED',
    ...page.value,
    parameters: param
  })
  totalCount.value = res?.totalCount ?? 0
  return res?.data ?? []
}

const page = ref({ pageNo: 1, pageSize: 40 })
const organizationDatas = shallowRef([])
const seachOrganization = async (pageNo) => {
  page.value.pageNo = pageNo ?? 1
  const param = {
    systemId: selectSystem.value.id,
    systemAliasId: selectSystem.value.alias?.id,
    keyword: keyowrd.value,
  }
  let loadingInstance = ElLoading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  organizationDatas.value = await getOrganizationBySystem(param)
  loadingInstance?.close()
}
const sizeChange = (size) => {
  page.value.pageSize = size
  seachOrganization()
}
const currentChange = (pageNo) => { 
  seachOrganization(pageNo)
}

const selectSystem = shallowRef(null)
// 选择企业后去掉子系统
const systemEntrance = async (systeminfo, specialSystem) => {
  let loadingInstance = ElLoading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  selectSystem.value = systeminfo
  keyowrd.value = ''
  page.value.pageNo = 1
  const organizationList = await getOrganizationBySystem({systemId: systeminfo.id, systemAliasId: systeminfo.alias?.id})
  loadingInstance?.close()
  if(organizationList.length === 1 || (specialSystem === 'chain' && organizationList.length > 0)) {
    toSystem({
      organization: organizationList[0].code,
    })
  }else if(organizationList.length > 1) {
    organizationModalShow.value = true
    organizationDatas.value = organizationList
  }else {
    pgMessage.error('当前子系统无授权组织！')
  }
}

// 跳转到子系统
const toSystem = async({organization}) => {
  organizationModalShow.value = false
  let loadingInstance = ElLoading.service({ background: 'rgba(0,0,0,0)', fullscreen: true })
  const [res] = await get('rest/security/auth/getTicketByToken', {
    tokenId: proxy.$store.state.user.currentToken.id,
    organizationCode: organization,
    systemCode: selectSystem.value.code,
    systemAliasCode: selectSystem.value.alias?.code,
  })
  loadingInstance?.close()
  if(res?.data) {
    const openUrl = getFullUrl(`${selectSystem.value.entry}?ticket=${res.data}`)
    const win1 = window.open(openUrl)
    if (!win1 || !win1.location) {
      pgMessage.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
    }
  }

}

const route = useRoute()
// 16订货登录后自动跳转到业务系统
const chainRouter = () => {
  if(route.query.CHAIN_JUMP) {
    sessionStorage.setItem(`${proxy.GLOBAL.cacheKey}_CHAIN_JUMP`, true)
    delete route.query.CHAIN_JUMP
    return false
  }
  let sessionValue = sessionStorage.getItem(`${proxy.GLOBAL.cacheKey}_CHAIN_JUMP`)
  if (sessionValue) return false
  let systeminfo = null
  // 从系统列表中筛选，如果有16订货系统，就自动跳转,其实可以根据systemCode来判断，但是16订货的服务器是另外的，所以肯定不会授权灵科优联
  // 麻烦的就是如果是开发环境，就会自动跳了
  // 从系统列表中找到CHAIN系统的信息
  if (systemList.value.length > 0) {
    systeminfo = systemList.value.find((im) => {
      if (im.code == 'CHAIN') return im
    })
  }
  if (systeminfo) {
    // 如果找到了16订货系统，就记录一个变量，总不能每次进个人中心都跳转到系统里呀，所以，就跳转一次
    // 虽然用localStorage，但是我需要在系统或者页面关闭的时候，要把这个参数给他删除掉，用localStorage是为了防止刷新值丢失的问题所以不用sessionStorage
    sessionStorage.setItem(`${proxy.GLOBAL.cacheKey}_CHAIN_JUMP`, true)
    systemEntrance(systeminfo, 'chain')
  }
}
</script>
<style lang="scss">
.pg-passport-systemEnterNew{
  .system-list{
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    column-gap: 20px;
    row-gap: 24px;
    .system-list-item{
      height: 140px;
      display: flex;
      .system-list-item-content{
        flex: 1;
        display: flex;
        align-items: center;
        padding-left: 20px;
        border-radius: 12px;
        background-color: var(--color-white);
        transition: all .3s;
        cursor: pointer;
        .system-list-item-icon{
          width: 64px;
          height: 64px;
          background-color: #F8F7F7;
          border-radius: 12px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            max-width: 100%;
            max-height: 100%;
          }
        }
        .system-list-item-info{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding-left: 20px;
          padding-right: 10px;
          .name {
            font-size: 20px;
            color: #303434;
          }
          .title {
            font-size: 14px;
            padding: 4px 12px;
            line-height: normal;
            border-radius: 4px;
            color: rgba(54, 31, 8, 1);
            background-color: rgba(54, 31, 8, .1);
          }
          .title-vnion{
            color: rgba(33, 88, 246, 1);
            background-color: rgba(33, 88, 246, .1);
          }
          .title-link{
            color: rgba(17, 221, 219, 1);
            background-color: rgba(17, 221, 219, .1);
          }
          .title-reunion{
            color: rgba(7, 139, 241, 1);
            background-color: rgba(7, 139, 241, .1);
          }
        }
      }
    }
    .system-list-item:hover {
      .system-list-item-content{
        transform: translateY(-8px);
        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
        .system-list-item-info{
          .name{
            color: #FF8808;
          }
        }
      }
    }
  }
}
.pg-passport-dialog-select-organization{
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(6px);
  .el-dialog__header{
    padding: 0;
    .el-dialog__headerbtn{
      top: 80px;
      right: 140px;
      .el-dialog__close{
        color: var(--color-white);
        font-size: 36px;
      }
    }
    
  }
  .el-dialog__body{
    height: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    .title{
      padding: 80px 0 30px 0;
      color: var(--color-white);
      font-size: 20px;
      text-align: center;
    }
    .select-organization{
      display: flex;
      justify-content: center;
      .input-search{
        width: 500px;
        height: 50px;
        .el-input__inner{
          height: 50px;
          line-height: 50px;
          font-size: 18px;
          padding-left: 40px;
          border-radius: 12px;
        }
        .el-input__prefix{
          left: 10px;
        }
        .input-sea-icon{
          font-weight: bold;
          font-size: 18px;
        }
      }
    }
    .select-organization-list{
      flex: 1;
      min-height: 0;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      column-gap: 40px;
      row-gap: 40px;
      padding: 60px 140px 50px 140px;
      overflow: auto;
      .select-organization-list-item{ 
        width: calc(25% - 33px);
        height: 110px;
        .select-organization-list-item-content{
          height: 100%;
          display: flex;
          align-items: center;
          padding: 0 24px;
          border-radius: 20px;
          background-color: var(--color-white);
          cursor: pointer;
          transition: all .3s;
          .select-organization-list-item-icon{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            width: 62px;
            height: 62px;
            background-color: #F4F4F4;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 12px;
            font-size: 40px;
            color: #C3C3C3;
            img{
              max-width: 100%;
              max-height: 100%;
            }
          }
          .select-organization-list-item-name{
            color: #303434;
            font-size: 20px;
          }
        }
      }
      .select-organization-list-item:hover{
        .select-organization-list-item-content{
          transform: translateY(-8px);
          box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
          .select-organization-list-item-name{
            color: #FF8808;
          }
        }
      }
    }
    .select-organization-list-footer{
      padding-bottom: 40px;
      display: flex;
      justify-content: center;
      .el-pagination__total, .el-pagination__jump{
        color: var(--color-white);
      }
    }
  }
}
</style>